var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 14,
    viewBox: "0 0 73 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switch-/-Large-/-1.-Poker",
    transform: "translate(0 -6)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switcher",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Poker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2_PSPokerLogo_Pos_RGB",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M12.429 4.672c0 2.749-1.771 4.653-5.17 4.653H3.41v4.482H.157V.354h7.675c2.943 0 4.597 1.625 4.597 4.318m-3.385.038c0-1.29-.827-1.809-2.039-1.809H3.41v3.73h3.327c1.513 0 2.308-.595 2.308-1.92",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M28.74 7.113c0 4.558-3.328 6.887-7.444 6.887-4.115 0-7.442-2.329-7.442-6.887 0-4.635 3.327-6.968 7.442-6.968 4.116 0 7.445 2.333 7.445 6.968m-3.462 0c0-2.866-1.75-4.27-3.983-4.25-2.231.02-3.98 1.404-3.98 4.25 0 2.769 1.75 4.194 3.98 4.194s3.983-1.405 3.983-4.194",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    id: "Fill-8",
    d: "M36.247 8.268l-2.193 2.5v3.039h-3.257V.354h3.25V6.71L39.722.354h4.046l-5.315 5.682 5.904 7.77h-4.021l-4.089-5.538"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    id: "Fill-9",
    d: "M49.332 3.051v2.6h6.653v2.57h-6.653v2.835h7.418v2.75H46.08V.355h10.67v2.697h-7.418"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M64.712 8.978h-2.307v4.829h-3.252V.354h7.811c3.133 0 4.577 1.798 4.577 4.156 0 2.171-1.212 3.821-3.27 4.25l4 5.058h-3.942l-3.617-4.84zm-2.307-2.596h3.539c1.325 0 2.21-.499 2.21-1.71 0-1.29-.898-1.771-2.114-1.771h-3.635v3.481z",
    id: "Fill-10"
  }))))))));
}

SvgPoker.displayName = 'Poker';
export default SvgPoker;